import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup, Validators, FormArray, FormBuilder } from '@angular/forms';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
import * as L from "leaflet";
import { PhameeService } from '../../services/phamee.service';
import { FarmService } from 'src/app/services/farm-service.service';
declare var $: any;
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import * as XLSX from 'xlsx';

@Component({
  selector: 'smart-plot-yield',
  templateUrl: './plot-yield.component.html',
  styleUrls: ['./plot-yield.component.css', '../platform-color/platform-color.css']
})
export class PlotYieldComponent implements OnInit {

  userrole = sessionStorage.getItem("role");
  package = JSON.parse(sessionStorage.getItem("package"));
  step = 1;
  change_table = false;
  sheath_expand = false;
  post_expand = false;
  isTabLoading = false;
  tableRoundRows: any = [];
  tableYieldRows: any[] = [];
  limit: number = 12;
  page: number = 1;
  Round_limit: number = 100;
  total: any;

  @Input() plotId: string;
  @Input() farmId: string;
  @Input() cropId: string;
  @Input() zoneId: string;
  map: L.Map;
  map_focus: L.Map;
  polygon;
  marker;
  drawPluginOptions;
  numberOfLatLong = [];
  centerpoint = [];
  numberPloe = [];
  growthFormdata: any;

  FormCreateSubmit: FormGroup;
  FormEditSubmit: FormGroup;

  FormCreateYeild: FormGroup;
  FormEditYeild: FormGroup;

  // Round: any = 'allRound';
  Round: any = 'allYield';
  RoundList: any = [];
  DDRoundList: any = [];
  cropPoleList: any = [];
  lastRound: number = 1;
  startDate: any;
  endDate: any;
  harvestingDate: any = new Date();
  disabledendDate: boolean = true
  minDate: any;
  roundNo: any = '0';
  roundName: any
  poleNo: any = '0';
  inflorescenceNo: any = '0';
  inflorescenceName: any;
  gradeNo: any = '0';
  gradeName: any;
  cropPoleId: any;
  cropPoleName: any;
  inflorescenceList: any = [];
  gradeList: any = [];
  podSaved: any

  _id: any
  yield_type: any
  param_value: any
  pod_no: any
  FormPodList: FormGroup
  FormPoleList: FormGroup

  formDate: FormGroup;

  receive_date: any = '';

  yieldCount = 0;
  yieldPageList: any = [];
  plot: any;
  breedTypeId: any;
  plotInfo: any;
  yieldTemplate: any = {
    yield: []
  };

  yieldDataValue: any = [];
  fromDate: any = null;
  toDate: any = null;

  isEdit: boolean = false;
  yieldId: string;
  yieldDataInfo: any;

  isloading: boolean = false;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private phameeService: PhameeService,
    private farmService: FarmService,
    private route: ActivatedRoute,
    private location: Location,
    private cd: ChangeDetectorRef

  ) {
    this.FormCreateSubmit = this.fb.group({
      round: '',
      start_date: ['', Validators.required],
      end_date: ['', Validators.required],
    });
    this.FormEditSubmit = this.fb.group({
      id: '',
      round: '',
      start_date: ['', Validators.required],
      end_date: ['', Validators.required],
    });

    this.FormEditYeild = this.fb.group({
      pole_id: ['0', Validators.required],
      height: ['', Validators.required],
      plump: ['', Validators.required],
      weight: ['', Validators.required],
      grade: ['A', Validators.required],
      harvesting_date: [this.harvestingDate, Validators.required],
      detail: ['', Validators.required],
    })

    this.FormPodList = this.fb.group({
      podLengthId: '',
      podLengthNo: '',
      podLengthInputType: '',
      podLengthCropYield: '',
      podLengthOperator: '',
      podLengthBefore: '',
      podLength: '',
      podLengthSum: '',

      podCircumferenceId: '',
      podCircumferenceNo: '',
      podCircumferenceInputType: '',
      podCircumferenceCropYield: '',
      podCircumferenceOperator: '',
      podCircumferenceBefore: '',
      podCircumference: '',
      podCircumferenceSum: '',

      podWeightId: '',
      podWeightNo: '',
      podWeightInputType: '',
      podWeightCropYield: '',
      podWeightOperator: '',
      podWeightBefore: '',
      podWeight: '',
      podWeightSum: '',

      podGradeId: '',
      podGradeNo: '',
      podGradeInputType: '',
      podGradeCropYield: '',
      podGradeOperator: '',
      podGradeBefore: '',
      podGrade: '',
      podGradeSum: '',
    });
    this.FormPoleList = this.fb.group({

      avgPodLengthId: '',
      avgPodLengthNo: '',
      avgPodLengthInputType: '',
      avgPodLengthCropYield: '',
      avgPodLengthOperator: '',
      avgPodLengthBefore: '',
      avgPodLength: '',
      avgPodLengthSum: '',

      sumPodWeightId: '',
      sumPodWeightNo: '',
      sumPodWeightInputType: '',
      sumPodWeightCropYield: '',
      sumPodWeightOperator: '',
      sumPodWeightBefore: '',
      sumPodWeight: '',
      sumPodWeightSum: '',

      avgPodCircumferenceId: '',
      avgPodCircumferenceNo: '',
      avgPodCircumferenceInputType: '',
      avgPodCircumferenceCropYield: '',
      avgPodCircumferenceOperator: '',
      avgPodCircumferenceBefore: '',
      avgPodCircumference: '',
      avgPodCircumferenceSum: '',
    });
  }

  public ChangingQueryParams(params, handling) {
    const queryParams: Params = params;
    this.router.navigate(
      ['.'],
      {
        relativeTo: this.route,
        queryParams: queryParams,
        replaceUrl: true,
        queryParamsHandling: handling, // remove to replace all query params by provided
      });
  }

  reload() {
    this.isTabLoading = false;
    this.spinner.show();
    setTimeout(() => {
      this.isTabLoading = true;
      this.cancel_form();
      this.spinner.hide();
    }, 100);
  }
  checkData(data) {
    if (data) return data
    return '-'
  }

  ngOnInit(): void {
    this.spinner.show();
    setTimeout(async () => {
    }, 1000);
    this.initYieldTemplate();
    // this.getDatatable(this.page);
    // this.change_round_yield(this.Round, 1)
    this.createForm();
    this.formDate.controls.receive_date.valueChanges.subscribe(
      async (value) => {
        if (value != this.formDate.value['receive_date']) {
          this.fromDate = moment(value.split(" -")[0], 'DD MMM YYYY').set({ 'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0 }).format('YYYY-MM-DDTHH:mm:ss')
          this.toDate = moment(value.split(" -")[1], 'DD MMM YYYY').set({ 'hour': 23, 'minute': 59, 'second': 59, 'millisecond': 0 }).format('YYYY-MM-DDTHH:mm:ss')

          await this.getYieldData();
        }
      }
    );
    this.spinner.hide();
  }

  createForm() {
    this.formDate = this.fb.group({
      receive_date: [''],
    });
  }

  DateDDMMYYYY(data) {
    if (!data) return ''
    return moment(data, 'YYYY-MM-DD HH:mm:ss', 'Asia/Bangkok').format('DD/MM/YYYY')
  }

  selectstartDate(startdate) {
    if (startdate) {
      // this.minDate = new Date(startdate);
      // this.disabledendDate = false
      // this.endDate = null
      this.harvestingDate = startdate;
    }
  }
  getPage(pageNo: number) {
    this.page = pageNo;
    this.getDatatable(this.page);
  }
  getDatatable(page) {
    let data = {
      crop_id: this.cropId,
      page_no: page,
      // limit: 100
    }
    this.DDRoundList = []
    this.spinner.show();
    this.phameeService.getYieldDataTable(data)
      .subscribe(async success => {
        console.log("getYieldDataTable success : ", success)
        if (success.code == 200) {
          let response = success.data
          let RoundArray = [];
          let DDRoundArray = [];

          for (let i = 0; i < response.data.length; i++) {
            const element = response.data[i];
            RoundArray.push({
              id: element._id,
              text: `ผลผลิตรอบที่ ${element.round_no}`
            })
            DDRoundArray.push({
              id: element._id,
              text: element.round_no
            })
          }
          this.RoundList = RoundArray
          this.DDRoundList = DDRoundArray

          this.tableRoundRows = response.data
          // this.limit = response.limit
          // this.page = response.page_no
          // this.total = response.total_rows
          this.lastRound = response.last_no + 1
        }
        this.spinner.hide();
        // last_no
      });
  }
  getPages(pageNoGrowth: number) {
    this.page = pageNoGrowth
  }

  async initYieldTemplate() {
    this.spinner.show();
    this.isloading = false;
    this.farmService.getPlotDetailByID(this.plotId).subscribe(async success => {

      if (success.code == 200) {
        this.plot = success.data[0];
        this.breedTypeId = this.plot.crop.breedType_id;
        this.plotInfo = this.plot.crop;
        const queryYieldTemplates = {
          farm_id: this.farmId,
          breed_type_id: this.breedTypeId,
          package_id: this.package.package_id
        }
        let yieldTemplates = [];
        let mainYieldTemplates = [];
        this.phameeService.getYieldTemplates(queryYieldTemplates).subscribe(async success => {
          if (success.code === 200) {
  
            yieldTemplates = success.data;
            yieldTemplates = yieldTemplates
            this.yieldTemplate = yieldTemplates.filter(item =>
              item.status === "Edited"
            ).reduce((prev, current) =>
              (parseInt(prev.template_name.split(prev.package_name)[1]) > parseInt(current.template_name.split(current.package_name)[1]))
                ? prev : current, { template_name: '', yield: [] })
          }
    
          if (!this.yieldTemplate.yield.length || success.code === 404) {
            const queryMainYieldTemplates = {
              breed_type_id: this.breedTypeId,
              org_id: this.plotInfo.org_id,
              package_id: this.package.package_id,
            }
            this.phameeService.getMainYieldTemplates(queryMainYieldTemplates).subscribe(async success => {
              if (success.code === 200) {
                mainYieldTemplates = success.data;
                this.yieldTemplate = mainYieldTemplates.filter(item =>
                  item.status === "Master"
                ).reduce((prev, current) =>
                  (parseInt(prev.template_name.split(prev.package_name)[1]) > parseInt(current.template_name.split(current.package_name)[1]))
                    ? prev : current, { template_name: '', yield: [] })
                this.yieldTemplate.yield.sort((a, b) => {
                  return a.no - b.no;
                });
                if (!this.yieldTemplate.yield.length) {
                  this.isloading = true;
                  this.tableYieldRows = [];
                  this.yieldPageList = [];
                  this.cd.detectChanges();
                } else {
                  this.isloading = true;
                  this.getYieldData();
                  this.spinner.hide();
                }
              } else {
                this.isloading = true;
                this.tableYieldRows = [];
                this.yieldPageList = [];
                this.cd.detectChanges();
              }
            })
          } else {
            this.yieldTemplate.yield.sort((a, b) => {
              return a.no - b.no;
            });
            this.isloading = true;
            this.getYieldData();
            this.spinner.hide();
          }
        })
      }
    });
  }

  change_round_yield(value: string, page: number) {
    this.spinner.show();
    let data = {
      crop_id: this.cropId,
      crop_yield_round_id: value == 'allYield' ? null : value,
      limit: this.limit,
      page_no: page,
    }
    if (value == 'allRound') {
      this.step = 0;
      this.spinner.hide();

    } else {
      this.step = 1;
      this.phameeService.getYieldDataforDataTable(data).subscribe(async success => {

        if (success.code == 200) {
          let response = success.data;
          this.tableYieldRows = response.table_row.data

          this.page = response.table_row.page_no
          // this.limit = 5
          if (response.table_row.data.length == response.table_row.total_rows) {
            if (this.limit !== response.table_row.data.length) this.total = response.table_row.total_rows + 1
            else this.total = response.table_row.total_rows
          } else {
            this.total = response.table_row.total_rows
          }
          // this.total = 5
        } else {
          this.tableYieldRows = [];
          this.total = 0
          this.page = 1
        }
        this.spinner.hide();
      });
    }
  }

  async getYieldData() {
    this.spinner.show();
    this.isloading = false;
    const queryYieldData = {
      plot_id: this.plotId,
      breed_type_id: this.breedTypeId,
      record_date_from: this.fromDate,
      record_date_to: this.toDate
    }
    if (!queryYieldData.record_date_from || !queryYieldData.record_date_from) {
      delete queryYieldData.record_date_from
      delete queryYieldData.record_date_to
    }
    this.phameeService.getYieldData(queryYieldData).subscribe(async success => {
      if (success.code === 200) {
        // create page manaul
        let yieldList = [];
        let page = [];
        this.tableYieldRows = await success.data.sort((a, b) => { return new Date(b.record_date).getTime() - new Date(a.record_date).getTime() })
        for (const row of this.tableYieldRows) {
          row.yield.sort((a, b) => {
            return a.no - b.no;
          });
          //create page manaul
          page.push(row);
          if (page.length === this.limit) {
            yieldList.push(page);
            page = [];
          }
        }

        if (page.length) {
          yieldList.push(page);
          page = [];
        }


        this.yieldPageList = yieldList;
        this.isloading = true;
        this.cd.detectChanges();
      } else {
        this.isloading = true;
        this.tableYieldRows = [];
        this.yieldPageList = [];
        this.cd.detectChanges();
      }
      this.spinner.hide();
    })
  }

  matchData(yieldData, yieldTemplate) {
    const data = yieldData.filter(item => item.name === yieldTemplate.name)
    if (data.length) {
      return data[0].value
    } else {
      return null
    }
  }

  add_yield() {
    this.isEdit = false;
    this.step = 2;
    let yieldTemplateForm = {}
    for (let yieldTemplate of this.yieldTemplate.yield) {
      if (yieldTemplate.show) {
        let defaultValue = ''
        switch (yieldTemplate.input_type) {
          case 'pole':
            defaultValue = ''
            yieldTemplate.no = 0
            break;
          case 'choice':
            defaultValue = yieldTemplate.input_choices[0].choice || ''
            break;
        }
        yieldTemplateForm[yieldTemplate.name] = [defaultValue, Validators.required]
      }
    }

    this.yieldTemplate.yield.sort((a, b) => {
      return a.no - b.no;
    });
    yieldTemplateForm["harvesting_date"] = [new Date, Validators.required]
    yieldTemplateForm["detail"] = [""]
    this.FormCreateYeild = this.fb.group(yieldTemplateForm)

    this.ChangingQueryParams({ option: 'createyield', farmId: this.farmId, plotId: this.plotId }, null)
    this.spinner.show();
    setTimeout(async () => {
      await this.getPlotforMap(null, 'map')
      this.spinner.hide();
    }, 500);
  }
  editYield(yieldInfo) {
    if (yieldInfo) {
      this.isEdit = true;
      this.step = 2;
      this.yieldId = yieldInfo._id;
      this.spinner.show();
      setTimeout(async () => {
        this.getPlotforMap(null, 'map')
        this.spinner.hide();
      }, 500);
      this.ChangingQueryParams({ option: 'edityield', farmId: this.farmId, plotId: this.plotId, yieldId: yieldInfo._id }, null)
      this.yieldDataInfo = yieldInfo;
      let yieldTemplateForm = {}
      for (let yieldTemplate of this.yieldTemplate.yield) {
        if (yieldTemplate.show) {
          let defaultValue = ''
          if (yieldTemplate.input_type === 'pole') {
            defaultValue = this.yieldDataInfo.crop_pole_id || ''
            yieldTemplate.no = 0
          } else {
            const result = this.yieldDataInfo.yield.find((element) => element.name === yieldTemplate.name);
            defaultValue = result == undefined || result.value == '' ? '' : result.value;

          }
          yieldTemplateForm[yieldTemplate.name] = [defaultValue, Validators.required]
        }
      }
      this.yieldTemplate.yield.sort((a, b) => {
        return a.no - b.no;
      });
      yieldTemplateForm["harvesting_date"] = [new Date(this.yieldDataInfo.record_date), Validators.required]
      yieldTemplateForm["detail"] = [this.yieldDataInfo.detail];
      this.FormCreateYeild = this.fb.group(yieldTemplateForm)

    } else {
      this.cancel_form_to_yield();
    }

  }

  deleteYield(id) {
    this._id = id;
  }
  getYieldDataforEdit(id, type, grade) {
    this.spinner.show();
    let data = {
      id: id,
      yield_type: type,
      param_value: grade
    }
    this.phameeService.getYieldbyId(data).subscribe(async success => {

      if (success.code == 200) {
        let response = success.data
        let RoundNo = this.DDRoundList.filter(x => x.id == response.crop_yield_round_id)
        this.roundNo = response.crop_yield_round_id
        this.roundName = RoundNo[0].text
        this.poleNo = response.crop_pole_name;
        this.cropPoleId = response.crop_pole_id;
        this.cropPoleName = response.crop_pole_name
        this.gradeNo = grade;
        let gradeName = this.gradeList.filter(x => x.id == grade)
        this.gradeName = gradeName[0].text
        for (let i = 0; i < response.grade_list.length; i++) {
          const element = response.grade_list[i];
          if (element.grade == this.gradeNo) {
            for (let j = 0; j < response.grade_list[i].list.length; j++) {
              const elements = response.grade_list[i].list[j];
              console.log("getYieldbyId elements : ", elements)
              switch (elements.no) {
                case 5:
                  console.log("getYieldbyId 5 ")
                  this.FormPoleList.controls["avgPodLengthId"].setValue(elements._id);
                  this.FormPoleList.controls["avgPodLengthNo"].setValue(elements.no);
                  this.FormPoleList.controls["avgPodLengthInputType"].setValue(elements.input_type);
                  this.FormPoleList.controls["avgPodLengthCropYield"].setValue(elements.crop_yield);
                  this.FormPoleList.controls["avgPodLengthOperator"].setValue(elements.operator == "+" ? true : false);
                  this.FormPoleList.controls["avgPodLength"].setValue(elements.value == null ? '' : elements.value);
                  this.FormPoleList.controls["avgPodLengthBefore"].setValue(elements.before);
                  this.FormPoleList.controls["avgPodLengthSum"].setValue(elements.sum);
                  break;
                case 6:
                  console.log("getYieldbyId 6 ")
                  this.FormPoleList.controls["sumPodWeightId"].setValue(elements._id);
                  this.FormPoleList.controls["sumPodWeightNo"].setValue(elements.no);
                  this.FormPoleList.controls["sumPodWeightInputType"].setValue(elements.input_type);
                  this.FormPoleList.controls["sumPodWeightCropYield"].setValue(elements.crop_yield);
                  this.FormPoleList.controls["sumPodWeightOperator"].setValue(elements.operator == "+" ? true : false);
                  this.FormPoleList.controls["sumPodWeight"].setValue(elements.value == null ? '' : elements.value);
                  this.FormPoleList.controls["sumPodWeightBefore"].setValue(elements.before);
                  this.FormPoleList.controls["sumPodWeightSum"].setValue(elements.sum);
                  break;
                case 7:
                  console.log("getYieldbyId 7 ")
                  this.FormPoleList.controls["avgPodCircumferenceId"].setValue(elements._id);
                  this.FormPoleList.controls["avgPodCircumferenceNo"].setValue(elements.no);
                  this.FormPoleList.controls["avgPodCircumferenceInputType"].setValue(elements.input_type);
                  this.FormPoleList.controls["avgPodCircumferenceCropYield"].setValue(elements.crop_yield);
                  this.FormPoleList.controls["avgPodCircumferenceOperator"].setValue(elements.operator == "+" ? true : false);
                  this.FormPoleList.controls["avgPodCircumference"].setValue(elements.value == null ? '' : elements.value);
                  this.FormPoleList.controls["avgPodCircumferenceBefore"].setValue(elements.before);
                  this.FormPoleList.controls["avgPodCircumferenceSum"].setValue(elements.sum);
                  break;
              }
            }
          }
        }

        console.log("this.roundNo : ", this.roundNo)
        console.log("getYieldbyId this.FormPoleList : ", this.FormPoleList)
        this.spinner.hide();
      }
    });
  }
  add_round() {
    this.step = 3;
  }
  cancel_round_btn() {
    this.FormCreateSubmit.reset()
    this.FormCreateYeild.reset()
    this.step = 0;
  }
  editRound(id) {
    this.spinner.show();
    this.phameeService.getRoundDatabyId(id).subscribe(async success => {
      console.log("getRoundDatabyId success : ", success)
      if (success.code == 200) {
        this.step = 5;
        let response = success.data
        this.FormEditSubmit.controls["id"].setValue(id);
        this.FormEditSubmit.controls["round"].setValue(response.round_no);
        this.FormEditSubmit.controls["start_date"].setValue(new Date(response.start_date_string));
        this.FormEditSubmit.controls["end_date"].setValue(new Date(response.end_date_string));
        this.spinner.hide();
      }
    });
  }
  sheathzone() {
    if (this.sheath_expand == false)
      this.sheath_expand = true;
    else if (this.sheath_expand == true)
      this.sheath_expand = false;
  }
  postzone() {
    if (this.post_expand == false)
      this.post_expand = true;
    else if (this.post_expand == true)
      this.post_expand = false;
  }
  chkConfirmCreateSubmit() {
    let yieldDataValue = {
      yield: this.yieldTemplate.yield
    }
    // this.spinner.show();
    // this.FormCreateSubmit.controls["round"].setValue(this.lastRound);
    // console.log("this.FormSubmit.value : ", this.FormCreateSubmit.value)
    // let data = {
    //   crop_id: this.cropId,
    //   plot_id: this.plotId,
    //   zone_id: this.zoneId,
    //   round_no: this.FormCreateSubmit.value.round,
    //   start_date_string: moment(this.FormCreateSubmit.value.start_date, 'YYYY-MM-DD HH:mm:ss', 'Asia/Bangkok').format('YYYY-MM-DD'),
    //   end_date_string: moment(this.FormCreateSubmit.value.end_date, 'YYYY-MM-DD HH:mm:ss', 'Asia/Bangkok').format('YYYY-MM-DD')
    // }
    // console.log("data : ", data)
    // this.phameeService.addYieldRound(data).subscribe(async success => {
    //   console.log("addYieldRound success : ", success)
    //   this.spinner.hide();
    //   if (success.code == 200) {
    //     $('#addroundSuccessmodal').modal('show');
    //   } else {
    //     $('#addroundFailmodal').modal('show');
    //   }
    // });
  }
  chkConfirmEditSubmit() {
    this.spinner.show();
    console.log("this.FormSubmit.value : ", this.FormEditSubmit.value)
    let data = {
      id: this.FormEditSubmit.value.id,
      round_no: this.FormEditSubmit.value.round,
      start_date_string: moment(this.FormEditSubmit.value.start_date, 'YYYY-MM-DD HH:mm:ss', 'Asia/Bangkok').format('YYYY-MM-DD'),
      end_date_string: moment(this.FormEditSubmit.value.end_date, 'YYYY-MM-DD HH:mm:ss', 'Asia/Bangkok').format('YYYY-MM-DD')
    }
    console.log("editYieldRound data : ", data)
    this.phameeService.editYieldRound(data).subscribe(async success => {
      console.log("editYieldRound success : ", success)
      this.spinner.hide();
      if (success.code == 200) {
        $('#editroundSuccessmodal').modal('show');
      } else {
        $('#editroundFailmodal').modal('show');
      }

    });
  }
  getPlotforMap(crop_round, map_id) {
    console.log("getPlotforMap : ", crop_round)
    this.phameeService.getPlotbyPlotId(this.plotId)
      .subscribe(async success => {
        console.log("plot grownth !@!!!! success : ", success)
        if (success.code == 200) {
          let data = success.data;
          console.log("data : ", data)

          let polygonDetail = {
            coordinates: data[0].coordinates,
            zone: {
              color: data[0].zone.color,
              name: data[0].zone.name
            }
          }

          await this.getMap(polygonDetail, crop_round, map_id)

          // data.forEach(element => {
          //   this.BreedTypeList.push({
          //     name: element.name,
          //     value: element._id
          //   })
          // });
        }
      });
  }
  async getMap(polygon, crop_round, map_id) {
    console.log("plot grownth polygon : ", polygon)
    console.log("this.map : ", this.map)
    this.numberOfLatLong = [];
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
    console.log("this.map : ", this.map)
    console.log("this.map_id : ", map_id)

    this.map = L.map(map_id, { zoomControl: false }).setView([polygon.coordinates.center.lat, polygon.coordinates.center.lon], polygon.coordinates.center.zoom_lv);
    L.control.zoom({ position: 'bottomright' }).addTo(this.map);
    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', { maxNativeZoom: 17, maxZoom: 18, minZoom: 5 })
      .addTo(this.map);
    for (let lt = 0; lt < polygon.coordinates.map_polygon.length; lt++) {
      this.numberOfLatLong[lt] = [polygon.coordinates.map_polygon[lt].lat, polygon.coordinates.map_polygon[lt].lon];
    }
    let latlong = this.numberOfLatLong;
    console.log("plot grownth latlong ::: ", latlong)
    this.polygon = L.polygon(
      [
        [latlong],
      ],
      {
        color: polygon.zone.color,
        fillColor: polygon.zone.color,
        fillOpacity: 0.2,

      },
    ).addTo(this.map);
    this.polygon.bindPopup(polygon.zone.name);
    console.log("b4 getCropPloe :", crop_round)
    this.getCropPloe(crop_round)

  }

  getCropPloe(crop_round) {
    console.log("getCropPloe : ", crop_round)
    // this.phameeService.getYieldCropPoleByCropId(this.cropId, crop_round)
    const query = {
      crop_id: this.cropId,
    }
    this.phameeService.getCropPloes(query)
      .subscribe(async success => {
        console.log("plot grownth getYieldCropPoleByCropId success : ", success)
        if (success.code == 200) {
          let data = success.data;
          console.log("plot grownth data : ", data)
          if (data.length > 0) {
            let cropPoleArray = [];
            for (let i = 0; i < data.length; i++) {
              this.numberPloe[i] = [data[i].coordinates.map_point.lat, data[i].coordinates.map_point.lon];
              let label: string = '<img style="width: 28px;height: 33px;" src="./assets/img/1w.png" alt=""><div style="text-align: center;width:28px;color: #000000;  position: absolute;top: 5%;"> ' + data[i].no + ' </div>'
              this.marker = L.marker(this.numberPloe[i], {
                icon: L.divIcon({
                  className: "number-icon",
                  iconSize: [30, 30],
                  iconAnchor: [15, 40],
                  popupAnchor: [3, -40],
                  html: label
                })
              }).addTo(this.map);
              cropPoleArray.push(data[i])

            }
            this.cropPoleList = cropPoleArray
            this.cropPoleList.sort(function (a, b) {
              if (b.name.localeCompare(a.name)) { return 1; }
              if (b.name.localeCompare(a.name)) { return -1; }
              return 0;
            });
            console.log("getCropPloe this.cropPoleList : ", this.cropPoleList)


          }
        }
        this.spinner.hide();

      });
  }

  selectRound(e) {
    console.log("selectRound : ", e)
    this.poleNo = '0'
    this.getCropPloe(e)
  }
  selectPole(e) {
    this.cropPoleId = e;
    let cropPoleName = this.cropPoleList.filter(x => x.id == e)
    this.cropPoleName = cropPoleName[0].text
    this.inflorescenceNo = '0'
    this.gradeNo = '0'
    this.FormPodList.reset()
    this.FormPoleList.reset()
    this.spinner.show()
    this.getInflorescence()
  }
  getInflorescence() {
    let data = {
      dom_id: 'growth',
      sub_dom_id: 'inflorescence'
    }
    this.phameeService.getOrgParam(data)
      .subscribe(async success => {
        console.log("getOrgParam success", success)
        let inflorescenceArray = [];
        if (success.code == 200) {
          let data = success.data
          data.sort(function (a, b) {
            if (a._id < b._id) { return -1; }
            if (a._id > b._id) { return 1; }
            return 0;
          });
          for (let i = 0; i < data.length; i++) {
            inflorescenceArray.push({
              id: data[i].param_id,
              text: data[i].param_name
            })
          }
          this.inflorescenceList = inflorescenceArray
        }
        this.getGrade()
      });
  }
  getGrade() {
    let data = {
      dom_id: 'yield',
      sub_dom_id: 'grade'
    }
    this.phameeService.getOrgParam(data)
      .subscribe(async success => {
        console.log("getOrgParam success", success)
        let gradeArray = [];
        if (success.code == 200) {
          let data = success.data
          data.sort(function (a, b) {
            if (a._id < b._id) { return -1; }
            if (a._id > b._id) { return 1; }
            return 0;
          });
          for (let i = 0; i < data.length; i++) {
            gradeArray.push({
              id: data[i].param_id,
              text: data[i].param_name
            })
          }
          this.gradeList = gradeArray
          console.log("this.gradeList : ", this.gradeList)
        }
        this.spinner.hide()

      });
  }

  selectInflorescence(e) {
    this.spinner.show()
    let inflorescenceName = this.inflorescenceList.filter(x => x.id == e)
    this.inflorescenceName = inflorescenceName[0].text
    let data = {
      crop_id: this.cropId,
      crop_yield_round_id: this.roundNo,
      crop_pole_id: this.poleNo,
      yield_type: 'inflorescence',
      param_value: e
    }
    this.phameeService.getFormYieldData(data)
      .subscribe(async success => {
        console.log("getFormYieldData success", success)
        let response = success.data
        console.log("response : ", response)
        for (let i = 0; i < response[0].length; i++) {
          const element = response[0][i];
          for (let j = 0; j < element.length; j++) {
            const elements = element[j];
            switch (elements.no) {
              case 0:
                console.log("0 ", elements.value)
                this.podSaved = elements.value == null ? '-' : elements.value
                break;
              case 1:
                console.log("1 ")
                this.FormPodList.controls["podLengthId"].setValue(elements._id);
                this.FormPodList.controls["podLengthNo"].setValue(elements.no);
                this.FormPodList.controls["podLengthInputType"].setValue(elements.input_type);
                this.FormPodList.controls["podLengthCropYield"].setValue(elements.yield);
                this.FormPodList.controls["podLengthOperator"].setValue(elements.operator == "+" ? true : false);
                this.FormPodList.controls["podLength"].setValue(elements.value == null ? '' : elements.value);
                this.FormPodList.controls["podLengthBefore"].setValue(elements.before);
                this.FormPodList.controls["podLengthSum"].setValue(elements.sum);
                break;
              case 2:
                console.log("2 ")
                this.FormPodList.controls["podCircumferenceId"].setValue(elements._id);
                this.FormPodList.controls["podCircumferenceNo"].setValue(elements.no);
                this.FormPodList.controls["podCircumferenceInputType"].setValue(elements.input_type);
                this.FormPodList.controls["podCircumferenceCropYield"].setValue(elements.yield);
                this.FormPodList.controls["podCircumferenceOperator"].setValue(elements.operator == "+" ? true : false);
                this.FormPodList.controls["podCircumference"].setValue(elements.value == null ? '' : elements.value);
                this.FormPodList.controls["podCircumferenceBefore"].setValue(elements.before);
                this.FormPodList.controls["podCircumferenceSum"].setValue(elements.sum);
                break;
              case 3:
                console.log("3 ")
                this.FormPodList.controls["podWeightId"].setValue(elements._id);
                this.FormPodList.controls["podWeightNo"].setValue(elements.no);
                this.FormPodList.controls["podWeightInputType"].setValue(elements.input_type);
                this.FormPodList.controls["podWeightCropYield"].setValue(elements.yield);
                this.FormPodList.controls["podWeightOperator"].setValue(elements.operator == "+" ? true : false);
                this.FormPodList.controls["podWeight"].setValue(elements.value == null ? '' : elements.value);
                this.FormPodList.controls["podWeightBefore"].setValue(elements.before);
                this.FormPodList.controls["podWeightSum"].setValue(elements.sum);
                break;
              case 4:
                console.log("4 ")
                this.FormPodList.controls["podGradeId"].setValue(elements._id);
                this.FormPodList.controls["podGradeNo"].setValue(elements.no);
                this.FormPodList.controls["podGradeInputType"].setValue(elements.input_type);
                this.FormPodList.controls["podGradeCropYield"].setValue(elements.yield);
                this.FormPodList.controls["podGradeOperator"].setValue(elements.operator == "+" ? true : false);
                this.FormPodList.controls["podGrade"].setValue(elements.value == null ? '' : elements.value);
                this.FormPodList.controls["podGradeBefore"].setValue(elements.before);
                this.FormPodList.controls["podGradeSum"].setValue(elements.sum);
                break;
            }
          }

        }
        console.log("this.FormPodList : ", this.FormPodList)
        this.spinner.hide()

      });
  }

  selectGrade(e) {
    this.spinner.show()
    let gradeName = this.gradeList.filter(x => x.id == e)
    this.gradeName = gradeName[0].text
    let data = {
      crop_id: this.cropId,
      crop_yield_round_id: this.roundNo,
      crop_pole_id: this.poleNo,
      yield_type: 'grade',
      param_value: e
    }
    this.phameeService.getFormYieldData(data)
      .subscribe(async success => {
        console.log("getFormYieldData success", success)
        let response = success.data
        console.log("response : ", response)
        for (let i = 0; i < response[0].length; i++) {
          const element = response[0][i];
          for (let j = 0; j < element.length; j++) {
            const elements = element[j];
            switch (elements.no) {
              case 5:
                console.log("5 ")
                this.FormPoleList.controls["avgPodLengthId"].setValue(elements._id);
                this.FormPoleList.controls["avgPodLengthNo"].setValue(elements.no);
                this.FormPoleList.controls["avgPodLengthInputType"].setValue(elements.input_type);
                this.FormPoleList.controls["avgPodLengthCropYield"].setValue(elements.yield);
                this.FormPoleList.controls["avgPodLengthOperator"].setValue(elements.operator == "+" ? true : false);
                this.FormPoleList.controls["avgPodLength"].setValue(elements.value == null ? '' : elements.value);
                this.FormPoleList.controls["avgPodLengthBefore"].setValue(elements.before);
                this.FormPoleList.controls["avgPodLengthSum"].setValue(elements.sum);
                break;
              case 6:
                console.log("6 ")
                this.FormPoleList.controls["sumPodWeightId"].setValue(elements._id);
                this.FormPoleList.controls["sumPodWeightNo"].setValue(elements.no);
                this.FormPoleList.controls["sumPodWeightInputType"].setValue(elements.input_type);
                this.FormPoleList.controls["sumPodWeightCropYield"].setValue(elements.yield);
                this.FormPoleList.controls["sumPodWeightOperator"].setValue(elements.operator == "+" ? true : false);
                this.FormPoleList.controls["sumPodWeight"].setValue(elements.value == null ? '' : elements.value);
                this.FormPoleList.controls["sumPodWeightBefore"].setValue(elements.before);
                this.FormPoleList.controls["sumPodWeightSum"].setValue(elements.sum);
                break;
              case 7:
                console.log("7 ")
                this.FormPoleList.controls["avgPodCircumferenceId"].setValue(elements._id);
                this.FormPoleList.controls["avgPodCircumferenceNo"].setValue(elements.no);
                this.FormPoleList.controls["avgPodCircumferenceInputType"].setValue(elements.input_type);
                this.FormPoleList.controls["avgPodCircumferenceCropYield"].setValue(elements.yield);
                this.FormPoleList.controls["avgPodCircumferenceOperator"].setValue(elements.operator == "+" ? true : false);
                this.FormPoleList.controls["avgPodCircumference"].setValue(elements.value == null ? '' : elements.value);
                this.FormPoleList.controls["avgPodCircumferenceBefore"].setValue(elements.before);
                this.FormPoleList.controls["avgPodCircumferenceSum"].setValue(elements.sum);
                break;
            }
          }

        }

        this.spinner.hide()

      });
  }
  validatePodForm() {
    if (!this.FormPodList.value.podLength && !this.FormPodList.value.podCircumference && !this.FormPodList.value.podWeight && !this.FormPodList.value.podGrade) {
      return false
    }
    return true
  }
  chkConfirmSubmit() {
    console.log("this.Form.value : ", this.FormCreateYeild.value)
    if (this.FormCreateYeild.valid) {
      this.spinner.show();
      const yieldList = []
      for (const item of this.yieldTemplate.yield) {
        if (item.show) {
          const data = {
            name: item.name,
            no: item.no,
            input_type: item.input_type,
          }
          yieldList.push(data)
        }
      }
      const harvesting_date = this.FormCreateYeild.controls['harvesting_date'].value;
      harvesting_date.setHours(harvesting_date.getHours() + 7);
      harvesting_date.setUTCHours(0, 0, 0, 0);
      let cropPlotSelected = null;
        let yieldData: any = {
        org_id: this.plotInfo.org_id,
        child_org_id: this.plotInfo.child_org_id,
        farm_id: sessionStorage.getItem("farmId"),
        plot_id: this.plotInfo.plot_id,
        zone_id: this.plotInfo.zone_id,
        crop_id: this.plotInfo.id,
        crop_name: this.plotInfo.name,
        crop_startDate: this.plotInfo.startDate,
        crop_endDate: this.plotInfo.endDate,
        breed_type_id: this.plotInfo.breedType_id,
        breed_type_name: this.plotInfo.breed_type.name,
        planting_type_id: this.plotInfo.plantingType_id,
        planting_type_name: this.plotInfo.planting_type.name,
        yield: yieldList,
        record_date: harvesting_date,
        detail: this.FormCreateYeild.controls['detail'].value,
      }
      for (const key in this.FormCreateYeild.value) {
        yieldData.yield.map((item) => {
          delete item['show'];
          if (item.name === key) {
            if (item.input_type === 'pole') {
              cropPlotSelected = this.cropPoleList.find((item) => {
                return item._id === this.FormCreateYeild.value[key]
              })
              item.value = cropPlotSelected.name.toString() + ' - no.' + cropPlotSelected.no.toString();
              yieldData.crop_pole_id = cropPlotSelected._id
              yieldData.crop_pole_no = cropPlotSelected.no
            } else {
              item.value = this.FormCreateYeild.value[key].toString()
            }
            if (this.isEdit) {
              this.yieldDataInfo.yield.find(data => {
                if (data.name === item.name) {
                  item._id = data._id;
                }
              })
            }
          }
        })
      }
      this.spinner.hide();
      if (this.isEdit) {
        this.phameeService.updateYieldData(this.yieldId, yieldData).subscribe(async success => {
          console.log("CreateYieldData success : ", success)
          this.spinner.hide();
          if (success.code == 200) {
            this.getYieldData();
            $('#edityieldSuccessmodal').modal('show');
          } else {
            $('#addyieldFailmodal').modal('show');
          }
        });
      } else {
        this.phameeService.createYieldData(yieldData).subscribe(async success => {
          console.log("CreateYieldData success : ", success)
          this.spinner.hide();
          if (success.code == 200) {
            this.getYieldData();
            $('#addyieldSuccessmodal').modal('show');
          } else {
            $('#addyieldFailmodal').modal('show');
          }
        });
      }
    } else {
      $('#addyieldAlertmodal').modal('show');
    }
  }
  validatePoleForm() {
    if (!this.FormPoleList.value.avgPodLength && !this.FormPoleList.value.sumPodWeight && !this.FormPoleList.value.avgPodCircumference) {
      return false
    }
    return true
  }
  chkConfirmPoleListSubmit() {
    console.log("this.FormPoleList.value : ", this.FormPoleList.value)
    if (this.validatePoleForm()) {
      this.spinner.show();
      let data = {
        zone_id: this.zoneId,
        plot_id: this.plotId,
        crop_id: this.cropId,
        crop_pole_id: this.cropPoleId,
        crop_pole_name: this.cropPoleName,
        crop_yield_round_id: this.roundNo,
        grade_list: [{
          grade: this.gradeNo,
          grade_name: this.gradeName,
          list: [
            {
              crop_yield_param_id: this.FormPoleList.value.avgPodLengthId,
              no: this.FormPoleList.value.avgPodLengthNo,
              input_type: this.FormPoleList.value.avgPodLengthInputType,
              crop_yield: this.FormPoleList.value.avgPodLengthCropYield,
              operator: this.FormPoleList.value.avgPodLengthOperator == true ? "+" : "-",
              before: this.FormPoleList.value.avgPodLengthBefore,
              value: this.FormPoleList.value.avgPodLength == "" ? null : this.FormPoleList.value.avgPodLength.toString(),
              sum: this.FormPoleList.value.avgPodLengthSum,
            },
            {
              crop_yield_param_id: this.FormPoleList.value.sumPodWeightId,
              no: this.FormPoleList.value.sumPodWeightNo,
              input_type: this.FormPoleList.value.sumPodWeightInputType,
              crop_yield: this.FormPoleList.value.sumPodWeightCropYield,
              operator: this.FormPoleList.value.sumPodWeightOperator == true ? "+" : "-",
              before: this.FormPoleList.value.sumPodWeightBefore,
              value: this.FormPoleList.value.sumPodWeight == "" ? null : this.FormPoleList.value.sumPodWeight.toString(),
              sum: this.FormPoleList.value.sumPodWeightSum,
            },
            {
              crop_yield_param_id: this.FormPoleList.value.avgPodCircumferenceId,
              no: this.FormPoleList.value.avgPodCircumferenceNo,
              input_type: this.FormPoleList.value.avgPodCircumferenceInputType,
              crop_yield: this.FormPoleList.value.avgPodCircumferenceCropYield,
              operator: this.FormPoleList.value.avgPodCircumferenceCropYield == true ? "+" : "-",
              before: this.FormPoleList.value.avgPodCircumferenceBefore,
              value: this.FormPoleList.value.avgPodCircumference == "" ? null : this.FormPoleList.value.avgPodCircumference.toString(),
              sum: this.FormPoleList.value.avgPodCircumferenceSum,
            }
          ]
        }]
      }
      console.log("data : ", data)
      this.phameeService.manageCropYieldData(data).subscribe(async success => {
        console.log("manageCropYieldData success : ", success)
        this.spinner.hide();
        if (success.code == 200) {
          $('#addyieldSuccessmodal').modal('show');
        } else {
          $('#addyieldFailmodal').modal('show');
        }
      });
    }
    else {
      $('#addyieldAlertmodal').modal('show');
    }
  }

  deletebyId() {
    this.spinner.show();
    this.phameeService.deleteYieldData(this._id)
      .subscribe(async success => {
        console.log("deletebyId success : ", success)
        if (success.code == 200) {
          $('#deleteyieldSuccessmodal').modal('show');
          this.getYieldData();
        } else {
          $('#deleteyieldFailmodal').modal('show');
        }
        this.spinner.hide();
      });
  }

  export_round() {
    this.spinner.show();
    this.phameeService.exportYieldRound(this.cropId)
      .subscribe(async success => {
        console.log("exportYieldRound success : ", success)
        if (success.code == 200) {
          let result = success.data
          let itemsFormatted = [];
          result.forEach(item => {
            console.log("exportGrowthData element ", item)
            itemsFormatted.push({
              'รอบที่': item.round_no,
              'วันที่เริ่มต้นเก็บผลผลิต': item.start_date_string,
              'วันที่สิ้นสุดเก็บผลผลิต': item.end_date_string,
            });
          });
          var fileName = 'ข้อมูลรอบผลผลิต' + '.xlsx';
          var ws = XLSX.utils.json_to_sheet(itemsFormatted);
          var wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
          XLSX.writeFile(wb, fileName);
        }
        this.spinner.hide();
      });
  }
  export_yield_data() {
    this.spinner.show();
    let itemsFormatted = [];
    this.tableYieldRows.forEach(item => {
      console.log("exportYieldData element ", item)
      const data = {
        'วันที่เก็บผลผลิต': this.DateDDMMYYYY(item.record_date)
      };
      for (let row of this.yieldTemplate.yield) {
        const findYield = item.yield.find(yieldData => yieldData.name === row.name)
        if (findYield !== undefined) {
          data[row.name] = findYield.value;
        }else{
          data[row.name] = ''
        }
      }
      itemsFormatted.push(data);
    });
    var fileName = 'ข้อมูลผลผลิต' + '.xlsx';
    var ws = XLSX.utils.json_to_sheet(itemsFormatted);
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, fileName);
    this.spinner.hide();
  }

  async cancel_form() {
    this.step = 1;
    // this.FormCreateSubmit.reset()
    // this.FormEditSubmit.reset()
    // this.FormEditSubmit.reset()
    // this.FormPoleList.reset()
    // this.startDate = null;
    // this.endDate = null;
    // this.poleNo = '0';
    // this.roundNo = '0';
    // this.inflorescenceNo = '0';
    // this.gradeNo = '0';
    // this.Round = 'allRound'
    // this.FormCreateYeild.reset();
    this.initYieldTemplate();
    // this.getDatatable(1)
  }
  cancel_form_to_yield() {
    this.step = 1;
    // this.FormCreateSubmit.reset()
    // this.FormEditSubmit.reset()
    // this.FormEditSubmit.reset()
    // this.FormPoleList.reset()
    // this.startDate = null;
    // this.endDate = null;
    // this.poleNo = '0';
    // this.roundNo = '0';
    // this.roundName = '';
    // this.inflorescenceNo = '0';
    // this.gradeNo = '0';
    // this.FormCreateYeild.reset();
    this.initYieldTemplate();
    // this.change_round_yield(this.Round, 1)
    // this.back();
    this.ChangingQueryParams({ farmId: this.farmId, plotId: this.plotId, cropId: this.cropId, zoneId: this.zoneId }, null)
  }

  backtoRoundData() {
    this.cancel_form()
  }
  backtoYieldData() {
    this.cancel_form_to_yield()
  }
  back(): void {
    this.location.back();
  }
  onClickYield(yieldtab) {
    if (yieldtab == 'pod') {
      $('#tabY_pole').removeClass('underline-li');
      $('#tabY_pod').addClass('underline-li');
    } else if (yieldtab == 'pole') {
      $('#tabY_pod').removeClass('underline-li');
      $('#tabY_pole').addClass('underline-li');
    }
  }
}